import { render, staticRenderFns } from "./AddressSettingsComponent.vue?vue&type=template&id=432f5f17&"
import script from "./AddressSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./AddressSettingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports